import { Link } from 'react-router-dom';

export default function Footer() {
  const services = [
    { name: 'Tax-Free Retirement', href: '#services' },
    { name: 'Long-Term Care Planning', href: '#services' },
    { name: 'Business Preservation', href: '#services' },
    { name: 'Medicare Insurance', href: '#services' },
    { name: 'Estate Planning', href: '#services' },
    { name: 'Mortgage Protection', href: '#services' },
    { name: 'Lifetime Income', href: '#services' }
  ];

  const areas = [
    'Doylestown, PA',
    'New Britain, PA',
    'Chalfont, PA',
    'Montgomeryville, PA',
    'New Hope, PA',
    'Greater Philadelphia',
    'Horsham, PA'
  ];

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://advancedbenefitdesigns.com/wp-content/uploads/2025/02/ABD-LOGO-2-e1739980257597.png"
              alt="Advanced Benefit Designs"
              className="h-12 w-auto mb-6"
            />
            <p className="text-slate-300 text-sm leading-relaxed mb-6">
              Advanced Benefit Designs is dedicated to providing innovative solutions tailored to meet your business needs. Empowering growth with reliable, efficient, and cutting-edge services.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-teal-400">Services</h3>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <a
                    href={service.href}
                    className="text-slate-300 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                  >
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas We Serve */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-teal-400">Areas We Serve</h3>
            <ul className="space-y-2">
              {areas.map((area, index) => (
                <li key={index} className="text-slate-300 text-sm">
                  {area}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-teal-400">Get Connected</h3>
            <div className="space-y-4 text-sm">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-400 text-lg flex-shrink-0 mt-0.5"></i>
                <p className="text-slate-300">
                  Advanced Benefit Designs<br />
                  2225 Dorchester Street<br />
                  East Furlong, PA 18925
                </p>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-teal-400 text-lg"></i>
                <a href="tel:215-262-5456" className="text-slate-300 hover:text-teal-400 transition-colors">
                  215-262-5456
                </a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-400 text-lg flex-shrink-0 mt-0.5"></i>
                <a href="mailto:support@advancedbenefitsdesigns.com" className="text-slate-300 hover:text-teal-400 transition-colors break-all">
                  support@advancedbenefitsdesigns.com
                </a>
              </div>
            </div>

            <div className="mt-6">
              <div className="flex gap-3">
                <a
                  href="https://www.facebook.com/share/1A2sciAZtx/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-teal-500 text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://www.linkedin.com/company/advancedbenefitsdesigns/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-teal-500 text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
                <a
                  href="https://www.youtube.com/@AdvancedBenefitsDesigns"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-teal-500 text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-youtube-fill text-lg"></i>
                </a>
                <a
                  href="https://www.instagram.com/advancedbenefitdesigns?igsh=YTdxamRybzFrc2Vv"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center rounded-lg bg-white/10 hover:bg-teal-500 text-white transition-all duration-300 cursor-pointer"
                >
                  <i className="ri-instagram-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-400">
            <p>
              Copyright © Advanced Benefits 2025 | Powered by{' '}
              <a href="https://gcsrvllc.com/?Advancedbenefitsdesigns" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 transition-colors">
                Global Creative Services
              </a>
              {' | '}
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-teal-400 hover:text-teal-300 transition-colors">
                Website Builder
              </a>
            </p>
            <div className="flex gap-4">
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">
                Privacy Policy
              </a>
              <span>|</span>
              <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
